/* POYOPOP game popup: card match and picture poker at Poyoboy's table.
   Discounts: every play wins. Lose = the regular discount (5%). Win = 10/15/20% depending on how well you did.
   Each month a shopper gets a set number of plays (9) that can earn the good discounts; after that, plays only earn 5%.
   "Try again?" on the email screen swaps the current prize for another play. Once a code is claimed with an email,
   no more codes until next month: the games tab then plays for the arcade leaderboard (4-letter name + top scores).
   Everything resets at the start of each month. Saved state lives in localStorage:
   poyo_period (YYYY-MM), poyo_plays (plays used this month), poyo_claim ({code, tier, emailed, via}).
   Claiming: the shopper picks Email or Text. The claim subscribes them in Klaviyo (email or SMS list) and records a
   "Poyo Game Win" event with the code; a Klaviyo flow on that event sends the message.
   No dependencies (Lottie loads only if a .json animation slot is used). */
(function () {
  var root = document.getElementById('PoyoGame');
  var cfgEl = document.getElementById('PoyoGameConfig');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var T = cfg.tiers || {};       // { 5:{label,code}, 10:{...}, 15:{...}, 20:{...} }
  var PLAYS = cfg.plays === undefined ? 9 : +cfg.plays;
  var M = cfg.match || {};
  M.faces = (M.faces || []).map(function (u) { return String(u || '').trim(); });
  var P = cfg.poker || {};
  function get0(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  var mode = cfg.mode === 'poker' ? 'poker' : cfg.mode === 'ab' ? (get0('poyo_mode') || (Math.random() < 0.5 ? 'match' : 'poker')) : 'match';
  if (cfg.mode === 'ab') { try { localStorage.setItem('poyo_mode', mode); } catch (e) {} }
  var autoMode = mode;  // the game the popup opens into on its own (cfg.mode 'pick' = the games tab)
  var arcade = false;   // true once this month's code is claimed: games play for the leaderboard instead

  var $ = function (s) { return root.querySelector(s); };
  var modal = $('.pg-modal');
  var stage = $('[data-pg-stage]');
  var slot = $('[data-pg-slot]');
  var form = document.getElementById('PoyoGameForm');
  var KL = cfg.klaviyo || {};
  var SMS = cfg.sms || {};
  var via = 'email';    // how the shopper wants their code: 'email' or 'sms'
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var step = 'intro', lastFocus = null, autoTimer = null;

  // ---------- storage (always guarded) ----------
  function get(k, s) { try { return (s || localStorage).getItem(k); } catch (e) { return null; } }
  function set(k, v, s) { try { (s || localStorage).setItem(k, v); } catch (e) {} }
  function claim() { try { return JSON.parse(get('poyo_claim') || 'null'); } catch (e) { return null; } }
  // ---------- monthly plays ----------
  function period() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2); }
  function syncPeriod() { // first visit of a new month: everyone is eligible again
    if (get('poyo_period') === period()) return;
    set('poyo_period', period()); set('poyo_plays', '0'); set('poyo_claim', '');
  }
  function playsUsed() { return +(get('poyo_plays') || 0); }
  function playsLeft() { return Math.max(0, PLAYS - playsUsed()); }
  function claimed() { var c = claim(); return !!(c && c.code && c.emailed); } // this month's code is taken
  syncPeriod();
  function track(name, data) { if (window.MangaTrack) window.MangaTrack(name, Object.assign({ game: mode }, data || {})); }

  // ---------- public hook for your own animation code ----------
  function emit(name, extra) {
    window.dispatchEvent(new CustomEvent('poyo:stage', { detail: Object.assign({ stage: name, slot: slot }, extra || {}) }));
  }

  // ---------- media slots ----------
  var lottieReady = null;
  function loadLottie() {
    if (window.lottie) return Promise.resolve(window.lottie);
    if (lottieReady) return lottieReady;
    lottieReady = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie_light.min.js';
      s.onload = function () { res(window.lottie); }; s.onerror = rej;
      document.head.appendChild(s);
    });
    return lottieReady;
  }
  var current = null;
  // GIFs that play once only animate the first time a browser shows them, so one-shots get a fresh blob URL each time.
  var blobs = {}, blobUrl = {};
  function preload() {
    Object.keys(cfg.anim || {}).forEach(function (k) {
      var u = cfg.anim[k];
      if (!u || kind(u) !== 'img' || blobs[u]) return;
      blobs[u] = 'loading';
      fetch(u).then(function (r) { return r.blob(); }).then(function (b) { blobs[u] = b; }).catch(function () { blobs[u] = null; });
      var im = new Image(); im.src = u;
    });
  }
  function freshSrc(u) {
    var b = blobs[u];
    if (b && b !== 'loading') { if (blobUrl[u]) URL.revokeObjectURL(blobUrl[u]); blobUrl[u] = URL.createObjectURL(b); return blobUrl[u]; }
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'r=' + Date.now();
  }
  function kind(url) {
    var u = (url || '').split('?')[0].toLowerCase();
    if (/\.(json|lottie)$/.test(u)) return 'lottie';
    if (/\.(mp4|webm|mov|m4v)$/.test(u)) return 'video';
    return url ? 'img' : 'builtin';
  }
  // Plays a stage. Resolves when a one-shot finishes (or right away for loops).
  function play(name, loop) {
    var url = cfg.anim && cfg.anim[name];
    var k = kind(url);
    emit(name);
    if (current && current.destroy) current.destroy();
    current = null;
    if (k === 'builtin') { slot.innerHTML = poyoSVG(name); return wait(loop ? 0 : 600); }
    slot.innerHTML = '';
    if (k === 'img') {
      var img = new Image(); img.alt = ''; img.decoding = 'async'; img.src = loop ? url : freshSrc(url); slot.appendChild(img);
      return wait(loop ? 0 : (+cfg.reactMs || 1100));
    }
    if (k === 'video') {
      var v = document.createElement('video');
      v.src = url; v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.autoplay = true; v.loop = !!loop;
      slot.appendChild(v);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      return loop ? wait(0) : new Promise(function (r) { v.onended = r; setTimeout(r, 4000); });
    }
    return loadLottie().then(function (L) {
      return new Promise(function (r) {
        var anim = L.loadAnimation({ container: slot, renderer: 'svg', loop: !!loop, autoplay: true, path: url });
        current = anim;
        if (loop) r(); else { anim.addEventListener('complete', r); setTimeout(r, 4000); }
      });
    }).catch(function () { slot.innerHTML = poyoSVG(name); });
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, reduced ? 0 : ms); }); }

  // Built-in stand-in for Poyoboy until the 2D animations are in: round head, horns, ring eyes, zigzag grin, tie.
  function poyoSVG(name) {
    var sad = name === 'grumpy';
    var cheeks = name === 'happy' ? 1 : 0;
    return '<svg viewBox="0 0 200 220" role="img" aria-label="Poyo">' +
      '<g fill="none" stroke="#111" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M58 52 L48 14 L80 40 Z" fill="#111"/><path d="M142 52 L152 14 L120 40 Z" fill="#111"/>' +
      '<circle cx="100" cy="100" r="72" fill="#f6f2e8"/>' +
      '<ellipse cx="74" cy="88" rx="17" ry="22" fill="#f6f2e8"/><ellipse cx="74" cy="90" rx="7" ry="11" fill="#111"/>' +
      '<ellipse cx="128" cy="88" rx="13" ry="17" fill="#f6f2e8"/><circle cx="129" cy="91" r="5" fill="#111"/>' +
      (sad ? '<path d="M60 132 Q100 112 140 132"/>' :
        '<path d="M46 124 Q100 168 154 124" fill="#fff"/><path d="M52 130 L64 146 L76 136 L88 152 L100 140 L112 152 L124 136 L136 146 L148 130"/>') +
      '<path d="M92 172 L108 172 L114 208 L86 208 Z" fill="#f6f2e8"/><path d="M94 188 L106 188"/>' +
      '</g>' +
      '<circle cx="52" cy="118" r="10" fill="#9a9a9a" opacity="' + (cheeks * .7).toFixed(2) + '"/>' +
      '<circle cx="148" cy="118" r="10" fill="#9a9a9a" opacity="' + (cheeks * .7).toFixed(2) + '"/>' +
      '</svg>';
  }

  // ---------- card match ----------
  // Built-in card art: simple glyphs until your custom card assets are in. Swap via the "Card faces" setting.
  var GLYPHS = [
    '<path d="M50 12 L61 38 L89 40 L67 58 L74 86 L50 71 L26 86 L33 58 L11 40 L39 38 Z"/>',
    '<path d="M50 84 C20 62 10 46 10 32 C10 18 22 10 33 10 C42 10 48 16 50 22 C52 16 58 10 67 10 C78 10 90 18 90 32 C90 46 80 62 50 84 Z" fill="#111"/>',
    '<path d="M56 8 L24 54 L46 54 L40 92 L76 40 L54 40 Z"/>',
    '<circle cx="50" cy="44" r="30" fill="none"/><circle cx="38" cy="42" r="7"/><circle cx="62" cy="42" r="7"/><path d="M40 66 L44 60 L48 66 L52 60 L56 66 L60 60" fill="none"/><path d="M30 18 L22 4 L40 14 Z M70 18 L78 4 L60 14 Z"/>',
    '<path d="M50 8 C62 30 78 38 78 60 C78 78 65 90 50 90 C35 90 22 78 22 60 C22 46 32 40 36 28 C42 40 46 42 50 8 Z" fill="#111"/>',
    '<path d="M64 12 C44 16 30 32 30 52 C30 72 46 88 66 88 C54 80 48 66 48 50 C48 34 54 20 64 12 Z"/>',
    '<rect x="10" y="38" width="80" height="24" rx="4" fill="none"/><circle cx="64" cy="50" r="9"/><path d="M22 50 L44 50" fill="none"/>',
    '<ellipse cx="50" cy="50" rx="38" ry="22" fill="none"/><circle cx="50" cy="50" r="11"/>'
  ];
  function faceHTML(i) {
    var urls = M.faces || [];
    if (urls[i]) return '<img src="' + urls[i].replace(/"/g, '&quot;') + '" alt="">';
    return '<svg viewBox="0 0 100 100" aria-hidden="true"><g fill="#111" stroke="#111" stroke-width="5" stroke-linejoin="round" stroke-linecap="round">' + GLYPHS[i % GLYPHS.length] + '</g></svg>';
  }
  function backHTML() {
    return M.back ? '<img src="' + M.back.replace(/"/g, '&quot;') + '" alt="">' : '';
  }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  var mt = null; // match state
  function startMatch() {
    var pairs = Math.max(2, Math.min(8, +M.pairs || 6));
    var deck = [];
    for (var i = 0; i < pairs; i++) deck.push(i, i);
    shuffle(deck);
    mt = { deck: deck, pairs: pairs, found: 0, misses: 0, maxMiss: Math.max(1, +M.misses || 4), open: [], lock: true, done: false };
    show('match');
    var board = $('[data-pgm-board]');
    var cols = pairs <= 3 ? 3 : 4;
    board.style.setProperty('--pgm-cols', cols);
    board.style.setProperty('--pgm-rows', Math.ceil(deck.length / cols));
    board.innerHTML = deck.map(function (f, i) {
      return '<button type="button" class="pgm-card is-up" data-i="' + i + '" disabled aria-label="Card ' + (i + 1) + '">' +
        '<span class="pgm-in"><span class="pgm-back">' + backHTML() + '</span><span class="pgm-face">' + faceHTML(f) + '</span></span></button>';
    }).join('');
    lives();
    msg(M.peekText || 'Memorize the cards');
    play('deal', false).then(function () { if (mt && !mt.done) play('idle', true); });
    emit('match-start', { pairs: pairs, maxMiss: mt.maxMiss });
    var peek = M.peek === 0 ? 0 : (+M.peek || 2) * 1000;
    setTimeout(function () {
      if (!mt || mt.done) return;
      board.querySelectorAll('.pgm-card').forEach(function (b) { b.classList.remove('is-up'); b.disabled = false; });
      board.classList.add('is-shuffle');
      setTimeout(function () { board.classList.remove('is-shuffle'); }, 450);
      mt.lock = false;
      msg(M.playText || 'Find the pairs');
      mt.startedAt = Date.now();
      emit('match-go');
      // Move focus to the board (not a card) so keyboard users land in the game without a card looking picked.
      board.setAttribute('tabindex', '-1'); board.focus({ preventScroll: true });
    }, reduced ? Math.min(peek, 1500) : peek);
  }
  function msg(t) { $('[data-pgm-msg]').textContent = t; }
  function lives() {
    var left = mt.maxMiss - mt.misses, html = '';
    for (var i = 0; i < mt.maxMiss; i++) html += '<i class="' + (i < left ? 'is-on' : '') + '"></i>';
    var el = $('[data-pgm-lives]');
    el.innerHTML = html;
    el.setAttribute('aria-label', left + ' tries left');
  }
  function flip(btn, up) {
    btn.classList.toggle('is-up', up);
    btn.setAttribute('aria-label', 'Card ' + (+btn.dataset.i + 1) + (up ? ', showing' : ''));
  }
  function onCard(btn) {
    if (!mt || mt.lock || mt.done || btn.classList.contains('is-up')) return;
    flip(btn, true);
    emit('match-flip', { card: +btn.dataset.i });
    mt.open.push(btn);
    if (mt.open.length < 2) return;
    mt.lock = true;
    var a = mt.open[0], b = mt.open[1];
    mt.open = [];
    if (mt.deck[+a.dataset.i] === mt.deck[+b.dataset.i]) {
      a.classList.add('is-matched'); b.classList.add('is-matched');
      a.disabled = b.disabled = true;
      mt.found++;
      emit('match-pair', { found: mt.found, pairs: mt.pairs });
      if (mt.found === mt.pairs) { win(); return; }
      play('happy', false).then(function () { if (mt && !mt.done) play('idle', true); });
      mt.lock = false;
    } else {
      mt.misses++;
      lives();
      emit('match-miss', { misses: mt.misses, maxMiss: mt.maxMiss });
      a.classList.add('is-wrong'); b.classList.add('is-wrong');
      if (mt.misses >= mt.maxMiss) { setTimeout(lose, 650); return; }
      play('grumpy', false).then(function () { if (mt && !mt.done) play('idle', true); });
      setTimeout(function () {
        a.classList.remove('is-wrong'); b.classList.remove('is-wrong');
        flip(a, false); flip(b, false);
        mt.lock = false;
      }, reduced ? 400 : 800);
    }
  }
  function win() {
    mt.done = true;
    msg(M.winText || 'Cleared!');
    emit('match-win');
    play('happy', false).then(function () { finishMatch('clear'); });
  }
  function lose() {
    mt.done = true;
    $('[data-pgm-board]').querySelectorAll('.pgm-card').forEach(function (b) { b.classList.remove('is-wrong'); flip(b, true); b.disabled = true; });
    msg(M.loseText || 'Out of tries');
    emit('match-lose');
    play('grumpy', false).then(function () { finishMatch('miss'); });
  }
  function finishMatch(outcome) {
    var secs = mt.startedAt ? (Date.now() - mt.startedAt) / 1000 : 0;
    var score = outcome === 'clear' ? Math.max(100, Math.round(1000 - mt.misses * 120 - secs * 8)) : 0;
    finishGame(outcome, { misses: mt.misses, seconds: Math.round(secs), score: score });
  }
  // How good a discount this result earns. Lose = 5. Win = 10 / 15 / 20 by how well you played.
  function tierFor(outcome, extra) {
    if (outcome !== 'clear') return 5;
    if (mode === 'match') { var m = extra.misses || 0; return m === 0 ? 20 : m === 1 ? 15 : 10; }
    var coins = extra.coins || 0;
    return coins >= (+P.t20 || 30) ? 20 : coins >= (+P.t15 || 20) ? 15 : 10;
  }
  function finishGame(outcome, extra) {
    extra = extra || {};
    var score = extra.score || 0;
    if (arcade) { // code already claimed this month: this one counts for the leaderboard
      track('poyo_game_end', Object.assign({ outcome: outcome, arcade: true }, extra));
      setTimeout(function () { showInitials(score); }, reduced ? 0 : 900);
      return;
    }
    var used = playsUsed() + 1; set('poyo_plays', String(used));
    var tier = tierFor(outcome, extra), earned = tier;
    if (used > PLAYS) tier = 5; // out of good plays this month: only the regular discount
    var t = T[tier] || T[5] || { label: tier + '% OFF', code: 'POYO' + tier };
    var c = { label: t.label, code: t.code, terms: cfg.terms || '', tag: 'prize-' + String(t.code).toLowerCase(), tier: tier, earned: earned, outcome: outcome, emailed: false };
    set('poyo_claim', JSON.stringify(c));
    track('poyo_game_end', Object.assign({ outcome: outcome, tier: tier, earned: earned, plays_used: used }, extra));
    setTimeout(function () { showClaim(c); }, reduced ? 0 : 900);
  }
  root.addEventListener('click', function (e) { var b = e.target.closest('.pgm-card'); if (b) onCard(b); });

  // ---------- arcade leaderboard (games tab only) ----------
  // Storage: a shared scoreboard service when cfg.lb.endpoint is set (see /scoreboard in the theme docs),
  // otherwise this browser only. One board per game; higher score is better.
  var LBC = cfg.lb || {};
  var BAD = /^(FUCK|SHIT|CUNT|DICK|COCK|PUSS|TWAT|SLUT|WHOR|FAGS?|NIGG|NIGR|NAZI|KKKK|ANAL|ARSE|PISS|TITS|BICH|FCUK|SHT|CUM)/;
  var lbCache = {};
  function lbLocal(game) { try { return JSON.parse(localStorage.getItem('poyo_lb_' + game) || '[]'); } catch (e) { return []; } }
  function lbSort(list) { return list.sort(function (a, b) { return b.score - a.score || a.at - b.at; }); }
  function lbGet(game) {
    if (LBC.endpoint) {
      return fetch(LBC.endpoint + (LBC.endpoint.indexOf('?') > -1 ? '&' : '?') + 'game=' + game, { credentials: 'omit' })
        .then(function (r) { return r.json(); }).then(function (d) { return (lbCache[game] = d.scores || []); })
        .catch(function () { return lbCache[game] || []; });
    }
    return Promise.resolve(lbCache[game] = lbSort(lbLocal(game)).slice(0, 50));
  }
  function lbAdd(game, name, score) {
    var entry = { name: name, score: score, at: Date.now() };
    if (LBC.endpoint) {
      return fetch(LBC.endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ game: game, name: name, score: score }) })
        .then(function (r) { return r.json(); }).then(function (d) { lbCache[game] = d.scores || []; return { list: lbCache[game], rank: d.rank || 0 }; })
        .catch(function () { return { list: lbCache[game] || [], rank: 0 }; });
    }
    var list = lbSort(lbLocal(game).concat(entry)).slice(0, 50);
    set('poyo_lb_' + game, JSON.stringify(list));
    lbCache[game] = list;
    return Promise.resolve({ list: list, rank: list.indexOf(list.filter(function (x) { return x.at === entry.at; })[0]) + 1 });
  }
  function esc2(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // Top-4 strip across the top screen.
  function lbStrip(game, highlightAt) {
    var el = $('[data-lb-strip]'); if (!el) return;
    lbGet(game).then(function (list) {
      var top = list.slice(0, LBC.show || 4), html = '<span class="lb-title">' + esc2(LBC.title || 'Top 4') + '</span>';
      for (var i = 0; i < (LBC.show || 4); i++) {
        var x = top[i];
        html += '<span class="lb-row' + (x && highlightAt && x.at === highlightAt ? ' is-you' : '') + '"><i>' + (i + 1) + '</i><b>' + (x ? esc2(x.name) : '----') + '</b><em>' + (x ? x.score : '') + '</em></span>';
      }
      el.innerHTML = html;
    });
  }
  // #1 of each game on the picker cards.
  function lbBest() {
    ['match', 'poker'].forEach(function (g) {
      var el = root.querySelector('[data-pg-best="' + g + '"]'); if (!el) return;
      lbGet(g).then(function (list) { el.textContent = list[0] ? '#1 ' + list[0].name + ' · ' + list[0].score : (LBC.emptyBest || 'No high score yet'); });
    });
  }

  // Arcade name: 4 sketchy bars that fill in as you type, with the leaderboard underneath.
  var ini = null;
  function iniInput() { return $('[data-ini-input]'); }
  function showInitials(score) {
    ini = { score: score, saved: false };
    show('initials');
    var input = iniInput();
    input.value = score > 0 ? (get('poyo_initials') || '').slice(0, 4) : '';
    $('[data-ini-kick]').innerHTML = score > 0 ? esc2(LBC.scoreKick || 'Your score') + ' <b>' + score + '</b>' : esc2(LBC.noScore || 'No score this round. Win to get on the board.');
    root.querySelector('.ini').classList.toggle('is-noscore', !(score > 0));
    $('[data-ini-save]').hidden = !(score > 0);
    iniRender();
    iniBoard();
    play(score > 0 ? 'happy' : 'grumpy', score > 0);
    emit('high-score', { score: score, game: mode });
    if (score > 0) setTimeout(function () { input.focus({ preventScroll: true }); }, 80);
  }
  function iniName() { return (iniInput().value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4); }
  function iniRender() {
    var name = iniName(), input = iniInput();
    if (input.value !== name) input.value = name;
    root.querySelectorAll('[data-ini-bar]').forEach(function (b, i) {
      var ch = name[i] || '';
      if (b.dataset.ch !== ch) { b.dataset.ch = ch; b.querySelector('b').textContent = ch; if (ch) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); } }
      b.classList.toggle('is-filled', !!ch);
      b.classList.toggle('is-next', !ini.saved && i === Math.min(name.length, 3) && document.activeElement === input);
    });
    var bad = BAD.test(name);
    $('[data-ini-err]').hidden = !bad;
    $('[data-ini-save]').disabled = bad || name.length < 4 || ini.saved;
  }
  function iniBoard(highlightAt) {
    var ol = $('[data-ini-board]'); if (!ol) return;
    lbGet(mode).then(function (list) {
      var show5 = list.slice(0, 5), rows = '';
      show5.forEach(function (x, i) { rows += '<li class="' + (highlightAt && x.at === highlightAt ? 'is-you' : '') + '"><i>' + (i + 1) + '</i><b>' + esc2(x.name) + '</b><em>' + x.score + '</em></li>'; });
      var meIdx = highlightAt ? list.findIndex(function (x) { return x.at === highlightAt; }) : -1;
      if (meIdx > 4) rows += '<li class="is-gap">…</li><li class="is-you"><i>' + (meIdx + 1) + '</i><b>' + esc2(list[meIdx].name) + '</b><em>' + list[meIdx].score + '</em></li>';
      if (!rows) rows = '<li class="is-empty">' + esc2(LBC.emptyBoard || 'No scores yet. Be the first.') + '</li>';
      ol.innerHTML = rows;
    });
  }
  function iniSave() {
    if (!ini || ini.saved) return;
    var name = iniName(), score = ini.score;
    if (name.length < 4 || BAD.test(name)) return;
    ini.saved = true; set('poyo_initials', name); iniRender();
    lbAdd(mode, name, score).then(function (r) {
      var me = r.list.filter(function (x) { return x.name === name && x.score === score; })[0];
      lbStrip(mode, me && me.at);
      iniBoard(me && me.at);
      track('poyo_highscore', { name: name, score: score, rank: r.rank });
      banner(r.rank && r.rank <= (LBC.show || 4) ? 'You’re #' + r.rank + '!' : r.rank ? 'Saved. You’re #' + r.rank : 'Saved', 'is-win');
      setTimeout(function () { banner(''); }, reduced ? 300 : 1600);
    });
  }
  root.addEventListener('input', function (e) { if (ini && e.target.matches('[data-ini-input]')) iniRender(); });
  root.addEventListener('focusin', function (e) { if (ini && e.target.matches('[data-ini-input]')) iniRender(); });
  root.addEventListener('focusout', function (e) { if (ini && e.target.matches('[data-ini-input]')) setTimeout(iniRender, 0); });
  root.addEventListener('keydown', function (e) { if (ini && e.key === 'Enter' && e.target.matches('[data-ini-input]')) { e.preventDefault(); iniSave(); } });
  root.addEventListener('click', function (e) {
    if (!ini) return;
    if (e.target.closest('[data-ini-save]')) iniSave();
    else if (e.target.closest('[data-ini-again]')) { ini = null; newGame(); }
  });

  // ---------- title bar: which game is on the table ----------
  function gameLabel() {
    var el = $('[data-pg-game]'); if (!el) return;
    el.textContent = ((cfg.labels || {})[mode]) || (mode === 'poker' ? 'Picture poker' : 'Card match');
    playsPill();
  }
  function playsPill() { // title bar: plays left this month, or "Leaderboard" once the code is claimed
    var p = $('[data-pg-plays]'); if (!p) return;
    syncPeriod();
    p.textContent = claimed() ? (cfg.arcadePill || 'Leaderboard') : playsLeft() > 0 ? playsLeft() + ' / ' + PLAYS + ' plays' : (cfg.outPill || '5% plays');
  }

  // ---------- picture poker ----------
  // Pictures ranked best (0) to worst (5). Custom art: the first 6 "Card faces" lines, best first.
  var PK_GLYPHS = [
    '<g fill="none" stroke="#111" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"><path d="M30 32 L22 8 L44 24 Z M70 32 L78 8 L56 24 Z" fill="#111"/><circle cx="50" cy="56" r="30" fill="#fff"/><ellipse cx="40" cy="52" rx="7" ry="9"/><circle cx="40" cy="53" r="3" fill="#111"/><circle cx="61" cy="52" r="5"/><path d="M34 68 L40 74 L46 68 L52 74 L58 68 L64 74"/></g>',
    '<path d="M50 86 C20 64 10 48 10 34 C10 20 22 12 33 12 C42 12 48 18 50 24 C52 18 58 12 67 12 C78 12 90 20 90 34 C90 48 80 64 50 86 Z" fill="#111" stroke="#111" stroke-width="4" stroke-linejoin="round"/>',
    '<g stroke="#111" stroke-width="5" stroke-linejoin="round"><path d="M50 8 C62 30 80 38 80 60 C80 78 66 92 50 92 C34 92 20 78 20 60 C20 46 30 40 34 28 C40 40 46 42 50 8 Z" fill="#fff"/><path d="M50 52 C56 62 63 66 63 75 C63 83 57 88 50 88 C43 88 37 83 37 75 C37 67 44 63 50 52 Z" fill="#111" stroke-width="2"/></g>',
    '<path d="M58 6 L22 56 L46 56 L38 94 L80 38 L56 38 Z" fill="#111" stroke="#111" stroke-width="4" stroke-linejoin="round"/>',
    '<g fill="none" stroke="#111" stroke-width="5" stroke-linejoin="round" stroke-linecap="round"><path d="M66 10 C44 14 28 32 28 54 C28 76 46 92 68 92 C54 82 46 68 46 50 C46 34 54 20 66 10 Z" fill="#fff"/><path d="M70 30 L74 38 M78 48 L84 50 M72 62 L76 70" stroke-width="3"/></g>',
    '<path d="M50 10 L61 38 L90 40 L67 58 L75 88 L50 71 L25 88 L33 58 L10 40 L39 38 Z" fill="#fff" stroke="#111" stroke-width="5" stroke-linejoin="round"/>'
  ];
  var PK_HANDS = [['5 of a kind', 16], ['4 of a kind', 8], ['Full house', 6], ['3 of a kind', 4], ['2 pairs', 3], ['1 pair', 2]];
  function pkFace(f) {
    var u = M.faces[f];
    if (u) return '<img src="' + u.replace(/"/g, '&quot;') + '" alt="">';
    return '<svg viewBox="0 0 100 100" aria-hidden="true">' + PK_GLYPHS[f] + '</svg>';
  }
  function pkBack() { return M.back ? '<img src="' + M.back.replace(/"/g, '&quot;') + '" alt="">' : ''; }
  function pkName(f) { return (P.names && P.names[f]) || ['Poyo', 'Heart', 'Flame', 'Bolt', 'Moon', 'Star'][f]; }
  // Lower is better: [handType 0..6, then pictures of the groups, biggest group first].
  function pkRank(hand) {
    var c = {}; hand.forEach(function (f) { c[f] = (c[f] || 0) + 1; });
    var g = Object.keys(c).map(function (f) { return { f: +f, n: c[f] }; }).sort(function (a, b) { return b.n - a.n || a.f - b.f; });
    var n = g.map(function (x) { return x.n; }).join('');
    var type = n === '5' ? 0 : n === '41' ? 1 : n === '32' ? 2 : n === '311' ? 3 : n === '221' ? 4 : n === '2111' ? 5 : 6;
    return [type].concat(g.map(function (x) { return x.f; }));
  }
  function pkCompare(a, b) { // <0 a wins, >0 b wins, 0 draw
    var ra = pkRank(a), rb = pkRank(b);
    if (ra[0] === 6 && rb[0] === 6) return 0; // junk vs junk is a draw
    for (var i = 0; i < Math.max(ra.length, rb.length); i++) { var d = (ra[i] === undefined ? 9 : ra[i]) - (rb[i] === undefined ? 9 : rb[i]); if (d) return d; }
    return 0;
  }
  function pkHandName(hand) { var t = pkRank(hand)[0]; return t === 6 ? 'Junk' : PK_HANDS[t][0]; }

  var pk = null;
  function startPoker() {
    var coins = Math.max(1, +P.coins || 10);
    pk = { start: coins, coins: coins, bet: 1, maxBet: Math.max(1, +P.maxBet || 5), round: 0, rounds: Math.max(1, +P.rounds || 3), phase: 'idle' };
    show('poker');
    $('[data-pk-legend]').innerHTML = [0, 1, 2, 3, 4, 5].map(function (f) { return '<span title="' + pkName(f) + '">' + pkFace(f) + '</span>'; }).join('');
    $('[data-pk-pay]').innerHTML = PK_HANDS.map(function (h, i) { return '<div data-t="' + i + '"><span>' + h[0] + '</span><b>' + h[1] + '</b></div>'; }).join('');
    emit('poker-start', { rounds: pk.rounds, coins: coins });
    pkRound();
  }
  function pkDeck() { var d = []; for (var f = 0; f < 6; f++) for (var k = 0; k < 5; k++) d.push(f); return shuffle(d); }
  function pkCards(el, hand, up, sel) {
    el.innerHTML = hand.map(function (f, i) {
      return '<button type="button" class="pk-card' + (up ? ' is-up' : '') + (sel && sel[i] ? ' is-sel' : '') + '" data-pk-i="' + i + '" aria-pressed="' + (sel && sel[i] ? 'true' : 'false') + '" aria-label="' + (up ? pkName(f) : 'Face-down card') + '">' +
        '<span class="pgm-in"><span class="pk-back">' + pkBack() + '</span><span class="pk-face">' + pkFace(f) + '</span></span></button>';
    }).join('');
  }
  function pkHud() {
    $('[data-pk-coins]').textContent = pk.coins;
    $('[data-pk-betv]').textContent = pk.bet;
    var dots = ''; for (var r = 1; r <= pk.rounds; r++) dots += '<i class="' + (r < pk.round ? 'is-done' : r === pk.round ? 'is-now' : '') + '"></i>';
    var rd = $('[data-pk-round]'); rd.innerHTML = '<span>Round</span>' + dots; rd.setAttribute('aria-label', 'Round ' + pk.round + ' of ' + pk.rounds);
    var go = $('[data-pk-go]');
    if (pk.phase === 'select') go.textContent = pk.sel.some(Boolean) ? 'Draw' : 'Hold';
    else if (pk.phase === 'done') go.textContent = pk.round < pk.rounds && pk.coins > 0 ? 'Next round' : 'Claim your discount';
    // the last button label is long, so the hand-name tags step aside for it
    var mid = root.querySelector('.pk-mid'); if (mid) mid.classList.toggle('is-final', pk.phase === 'done' && !(pk.round < pk.rounds && pk.coins > 0));
    go.disabled = pk.phase === 'reveal' || pk.phase === 'dealing';
    $('[data-pk-bet]').disabled = pk.phase !== 'select';
  }
  function pkTags(d, y, res) {
    var dt = $('[data-pk-dtag]'), yt = $('[data-pk-ytag]');
    dt.textContent = d; yt.textContent = y;
    dt.className = 'pk-tag' + (d ? ' is-on' : '') + (res === 'lose' ? ' is-best' : '');
    yt.className = 'pk-tag' + (y ? ' is-on' : '') + (res === 'win' ? ' is-best' : '');
  }
  function banner(t, cls) { var b = $('[data-pk-banner]'); b.textContent = t || ''; b.className = 'pk-banner' + (t ? ' is-on' : '') + (cls ? ' ' + cls : ''); }
  // ---- card motion, after the handheld original: flat "squash" flips, cards fly off the top and slide back in ----
  function cardsOf(row) { return [].slice.call(row.querySelectorAll('.pk-card')); }
  function setFace(el, f, up) {
    el.querySelector('.pk-face').innerHTML = pkFace(f);
    el.setAttribute('aria-label', up ? pkName(f) : 'Face-down card');
  }
  function squash(el, up) { // flat flip: squeeze to a line, swap sides, open back up
    el.classList.remove('is-squash'); void el.offsetWidth; el.classList.add('is-squash');
    setTimeout(function () { el.classList.toggle('is-up', up); }, reduced ? 0 : 140);
    return wait(300).then(function () { el.classList.remove('is-squash'); });
  }
  function flyOut(el) { el.classList.remove('is-in'); el.classList.add('is-out'); return wait(340); }
  function flyIn(el) { el.classList.remove('is-out', 'is-in', 'is-hidden'); void el.offsetWidth; el.classList.add('is-in'); return wait(360).then(function () { el.classList.remove('is-in'); }); }
  function stagger(list, fn, gap) {
    return Promise.all(list.map(function (el, k) { return wait(k * gap).then(function () { return fn(el, k); }); }));
  }

  function pkRound() {
    pk.round++;
    pk.deck = pkDeck();
    pk.you = pk.deck.splice(0, 5); pk.dealer = pk.deck.splice(0, 5);
    pk.sel = [false, false, false, false, false];
    pk.bet = Math.min(pk.bet, pk.coins);
    pk.phase = 'dealing';
    var dRow = $('[data-pk-dealer]'), yRow = $('[data-pk-you]');
    pkCards(dRow, pk.dealer, false);
    pkCards(yRow, pk.you, false, pk.sel);
    cardsOf(dRow).concat(cardsOf(yRow)).forEach(function (c) { c.classList.add('is-hidden'); });
    root.querySelectorAll('[data-pk-pay] div').forEach(function (d) { d.classList.remove('is-hit'); });
    banner('');
    pkHud();
    pkTags('', '');
    play('deal', false).then(function () { if (pk && (pk.phase === 'select' || pk.phase === 'dealing')) play('idle', true); });
    emit('poker-deal', { round: pk.round, hand: pk.you.slice() });
    // deal one at a time from Poyoboy's hands: his card, your card, his card...
    var d = cardsOf(dRow), y = cardsOf(yRow), order = [];
    for (var i = 0; i < 5; i++) order.push(d[i], y[i]);
    stagger(order, flyIn, reduced ? 0 : 70)
      .then(function () { return stagger(y, function (el) { return squash(el, true); }, reduced ? 0 : 80); })
      .then(function () {
        if (!pk || pk.phase !== 'dealing') return;
        y.forEach(function (el, k) { el.setAttribute('aria-label', pkName(pk.you[k])); });
        pk.phase = 'select'; pkHud();
        banner(P.dealText || 'Tap cards to swap them');
      });
  }
  function pkDraw() {
    pk.phase = 'reveal'; pkHud(); banner('');
    var dRow = $('[data-pk-dealer]'), yRow = $('[data-pk-you]'), y = cardsOf(yRow), d = cardsOf(dRow);
    var picked = y.filter(function (el, k) { return pk.sel[k]; });
    var swapped = picked.length;
    pk.you = pk.you.map(function (f, i) { return pk.sel[i] ? pk.deck.shift() : f; });
    // Poyoboy keeps any matching cards; with nothing matching he keeps his best picture.
    var r = pkRank(pk.dealer), counts = {};
    pk.dealer.forEach(function (f) { counts[f] = (counts[f] || 0) + 1; });
    var best = Math.min.apply(null, pk.dealer), keptBest = false, dSwap = [];
    pk.dealer = pk.dealer.map(function (f, i) {
      var keep = r[0] < 6 ? counts[f] > 1 : (f === best && !keptBest && (keptBest = true));
      if (!keep) dSwap.push(d[i]);
      return keep ? f : pk.deck.shift();
    });
    pk.sel = [false, false, false, false, false];
    emit('poker-swap', { swapped: swapped });
    // 1. your picked cards flip face-down and fly off the top; new ones slide in face-down, then flip up
    stagger(picked, function (el) { return squash(el, false); }, reduced ? 0 : 80)
      .then(function () { return stagger(picked, function (el) { el.classList.remove('is-sel'); el.setAttribute('aria-pressed', 'false'); return flyOut(el); }, reduced ? 0 : 60); })
      .then(function () {
        picked.forEach(function (el) { var k = y.indexOf(el); setFace(el, pk.you[k], false); });
        return stagger(picked, flyIn, reduced ? 0 : 90);
      })
      .then(function () { return stagger(picked, function (el) { var k = y.indexOf(el); return squash(el, true).then(function () { el.setAttribute('aria-label', pkName(pk.you[k])); }); }, reduced ? 0 : 90); })
      // 2. Poyoboy swaps: his discards fly up and away, new cards slide into his row
      .then(function () { return stagger(dSwap, flyOut, reduced ? 0 : 60); })
      .then(function () { return stagger(dSwap, flyIn, reduced ? 0 : 90); })
      // 3. reveal: his row gathers to the middle, spreads back out, and all five flip at once
      .then(function () {
        var w = d[0].getBoundingClientRect().width + 5;
        d.forEach(function (el, k) { el.style.setProperty('--gx', ((2 - k) * w) + 'px'); });
        dRow.classList.add('is-gather');
        return wait(330);
      })
      .then(function () { dRow.classList.remove('is-gather'); return wait(300); })
      .then(function () {
        d.forEach(function (el, k) { setFace(el, pk.dealer[k], true); });
        return Promise.all(d.map(function (el) { return squash(el, true); }));
      })
      .then(function () { wait(120).then(pkSettle); });
  }
  function pkSettle() {
    var cmp = pkCompare(pk.you, pk.dealer), mine = pkRank(pk.you)[0], theirs = pkRank(pk.dealer)[0], delta = 0, res;
    if (cmp < 0) { delta = pk.bet * (mine < 6 ? PK_HANDS[mine][1] : 1); res = 'win'; }
    else if (cmp > 0) { delta = -pk.bet; res = 'lose'; }
    else res = 'draw';
    pk.coins = Math.max(0, pk.coins + delta);
    if (mine < 6) { var row = root.querySelector('[data-pk-pay] [data-t="' + mine + '"]'); if (row) row.classList.add('is-hit'); }
    pkTags(pkHandName(pk.dealer), pkHandName(pk.you), res);
    if (delta > 0) coinShower(Math.min(18, 4 + delta));
    var pop = $('[data-pk-pop]'); if (pop && delta) { pop.textContent = (delta > 0 ? '+' : '') + delta; pop.className = 'pk-pop ' + (delta > 0 ? 'is-up' : 'is-down'); void pop.offsetWidth; pop.classList.add('is-go'); }
    if (delta) { var fx = $('[data-pk-delta]'); fx.textContent = (delta > 0 ? '+' : '') + delta; fx.className = 'pk-delta ' + (delta > 0 ? 'is-up' : 'is-down'); void fx.offsetWidth; fx.classList.add('is-go'); }
    banner(res === 'win' ? pkHandName(pk.you) + '! +' + delta : res === 'lose' ? 'Poyoboy wins with ' + pkHandName(pk.dealer).toLowerCase() : 'Draw', 'is-' + res);
    pk.phase = 'done'; pkHud();
    emit('poker-' + res, { round: pk.round, you: pkHandName(pk.you), dealer: pkHandName(pk.dealer), delta: delta, coins: pk.coins });
    // Poyoboy is the dealer: he sulks when you win a hand and cheers when he does.
    play(res === 'win' ? 'grumpy' : res === 'lose' ? 'happy' : 'idle', res === 'draw').then(function () { if (pk && pk.phase === 'done') play('idle', true); });
  }
  // drawn coins tumble onto the table in front of Poyoboy when you win a hand
  function coinShower(n) {
    if (reduced) return;
    var top = root.querySelector('.ds-screen--top'); if (!top) return;
    for (var i = 0; i < n; i++) {
      var c = document.createElement('i');
      c.className = 'pk-coinfx';
      c.style.left = (38 + Math.random() * 24) + '%';
      c.style.setProperty('--dx', Math.round((Math.random() - .5) * 120) + 'px');
      c.style.setProperty('--r', Math.round(Math.random() * 540) + 'deg');
      c.style.animationDelay = (i * 45) + 'ms';
      top.appendChild(c);
      setTimeout(function (el) { el.remove(); }.bind(null, c), 1500 + i * 45);
    }
  }
  function pkNext() {
    if (pk.round < pk.rounds && pk.coins > 0) { pkRound(); return; }
    pk.phase = 'over';
    var outcome = pk.coins > pk.start ? 'clear' : 'miss';
    banner(outcome === 'clear' ? 'You finished up ' + (pk.coins - pk.start) + ' coins' : 'Poyoboy took the table');
    finishGame(outcome, { coins: pk.coins, start: pk.start, score: outcome === 'clear' ? pk.coins : 0 });
  }
  root.addEventListener('click', function (e) {
    if (!pk) return;
    var c = e.target.closest('[data-pk-you] .pk-card');
    if (c && pk.phase === 'select') {
      var i = +c.dataset.pkI; pk.sel[i] = !pk.sel[i];
      c.classList.toggle('is-sel', pk.sel[i]); c.setAttribute('aria-pressed', pk.sel[i] ? 'true' : 'false');
      emit('poker-select', { card: i, selected: pk.sel[i] });
      pkHud(); return;
    }
    if (e.target.closest('[data-pk-bet]') && pk.phase === 'select') {
      pk.bet = pk.bet >= Math.min(pk.maxBet, pk.coins) ? 1 : pk.bet + 1;
      emit('poker-bet', { bet: pk.bet }); pkHud(); return;
    }
    if (e.target.closest('[data-pk-go]')) {
      if (pk.phase === 'select') pkDraw();
      else if (pk.phase === 'done') pkNext();
    }
  });

  // ---------- open / close ----------
  function navOffset() {
    var n = document.getElementById('MangaStickyNav');
    var h = n && getComputedStyle(n).display !== 'none' ? n.offsetHeight : 0;
    root.style.setProperty('--pg-nav', h + 'px');
  }
  function show(stepName) {
    root.querySelectorAll('.pg-step').forEach(function (s) { s.hidden = s.dataset.step !== stepName; });
    step = stepName;
    var card = root.querySelector('.pg-card');
    card.classList.toggle('is-done', stepName === 'reveal');
    card.classList.toggle('is-match', stepName === 'match');
    card.classList.toggle('is-poker', mode === 'poker' && (stepName === 'poker' || stepName === 'claim'));
    card.classList.toggle('is-pick', stepName === 'pick');
    card.classList.toggle('is-arcade', arcade && ['match', 'poker', 'initials'].indexOf(stepName) > -1);
  }
  function open(source) {
    if (!modal.hidden) return;
    clearTimeout(autoTimer);
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('mcd-lock');
    preload();
    gameLabel();
    syncPeriod();
    var c = claim();
    if (c && c.code && !c.emailed) showClaim(c);                  // finish claiming the prize they just won
    else if (source === 'resume' && c && c.emailed) reveal(c, true);
    else if (source === 'demo' || (cfg.mode !== 'pick' && source !== 'tab' && source !== 'pick')) { mode = autoMode; newGame(); }
    else showPicker();                                           // games tab: pick card match or picture poker
    set('poyo_seen', '1', sessionStorage);
    track('poyo_open', { source: source });
  }
  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('mcd-lock');
    if (step !== 'reveal') set('poyo_snooze', String(Date.now() + (+root.dataset.snooze || 30) * 864e5));
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    track('poyo_close', { step: step });
  }

  // ---------- flow ----------
  // ---------- Klaviyo (sends the code) ----------
  function klPost(path, data) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL.key), {
      method: 'POST', credentials: 'omit',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({ data: data })
    }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
  }
  // who = { email } or { phone_number }. Subscribes them, then the event carries the code for the flow to send.
  function klaviyoClaim(c, who) {
    if (!KL.key) return Promise.resolve();
    var sms = !!who.phone_number, channel = sms ? 'sms' : 'email';
    var list = sms ? KL.smsList : KL.emailList;
    var consent = {}; consent[channel] = { marketing: { consent: 'SUBSCRIBED' } };
    var props = { poyo_code: c.code, poyo_label: c.label, poyo_tier: c.tier, poyo_channel: channel, poyo_game: mode, poyo_month: period() };
    var jobs = [klPost('events', { type: 'event', attributes: {
      properties: { code: c.code, label: c.label, tier: c.tier, channel: channel, game: mode, terms: c.terms || '' },
      unique_id: 'poyo-' + period() + '-' + (who.email || who.phone_number),
      metric: { data: { type: 'metric', attributes: { name: KL.metric || 'Poyo Game Win' } } },
      profile: { data: { type: 'profile', attributes: Object.assign({ properties: props }, who) } }
    } })];
    if (list) jobs.push(klPost('subscriptions', { type: 'subscription', attributes: {
      custom_source: 'Poyo game',
      profile: { data: { type: 'profile', attributes: Object.assign({ subscriptions: consent }, who) } }
    }, relationships: { list: { data: { type: 'list', id: list } } } }));
    return Promise.all(jobs);
  }
  // US numbers without a country code get +1; anything else needs a leading +.
  function e164(v) {
    var d = String(v || '').replace(/[^\d+]/g, '');
    if (d.charAt(0) === '+') d = '+' + d.slice(1).replace(/\+/g, '');
    else if (d.length === 10) d = '+1' + d;
    else if (d.length === 11 && d.charAt(0) === '1') d = '+' + d;
    else return '';
    return /^\+\d{8,15}$/.test(d) ? d : '';
  }

  // Email or Text: swaps the input, the ask line and the fine print.
  function setVia(v) {
    via = v === 'sms' && SMS.on ? 'sms' : 'email';
    var sms = via === 'sms';
    root.querySelectorAll('[data-pg-via]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.pgVia === via)); });
    var email = document.getElementById('PoyoGameEmail'), phone = document.getElementById('PoyoGamePhone');
    email.hidden = sms; email.required = !sms; email.disabled = sms;
    if (phone) { phone.hidden = !sms; phone.required = sms; }
    var el = $('[data-pg-email-lbl]'), pl = $('[data-pg-phone-lbl]'); if (el) el.hidden = sms; if (pl) pl.hidden = !sms;
    root.querySelectorAll('[data-pg-fine]').forEach(function (f) { f.hidden = f.dataset.pgFine !== via; });
    var ask = $('[data-pg-claim-ask]');
    if (ask) ask.textContent = sms ? (SMS.claimLine || 'Enter your mobile number and we’ll text your code.')
      : cfg.codeSource === 'app' ? (cfg.claimLineApp || 'Enter your email and we’ll send your code.') : ask.dataset.line;
    $('[data-pg-err]').hidden = true;
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pg-via]'); if (!b) return;
    setVia(b.dataset.pgVia); track('poyo_via', { via: via });
    var i = document.getElementById(via === 'sms' ? 'PoyoGamePhone' : 'PoyoGameEmail'); if (i) i.focus({ preventScroll: true });
  });

  // ---------- flow ----------
  // Claim step: an email or a phone number unlocks the code the shopper just won.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var c = claim();
    if (!c || !c.code) return;
    var err = $('[data-pg-err]');
    var btn = form.querySelector('.pg-go');
    function busy(on) { btn.disabled = on; if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); }
    function fail(msg, input) { busy(false); err.textContent = msg; err.hidden = false; if (input) input.focus(); }
    function done() {
      c.emailed = true; c.via = via; set('poyo_claim', JSON.stringify(c));
      set(via === 'sms' ? 'poyo_has_phone' : 'poyo_has_email', '1');
      track('poyo_signup', { prize: c.tag, tier: c.tier, via: via, plays_used: playsUsed() });
      reveal(c, false);
    }
    var offline = 'Couldn’t reach the store. Check your connection and try again.';

    if (via === 'sms') {
      var phone = document.getElementById('PoyoGamePhone'), num = e164(phone.value);
      if (!num) return fail(SMS.bad || 'That number doesn’t look right. Use a mobile number with area code.', phone);
      err.hidden = true; busy(true);
      klaviyoClaim(c, { phone_number: num }).then(done, function () { fail(offline); });
      return;
    }

    var email = form.querySelector('[type=email]');
    if (!email.value || !email.checkValidity()) return fail('That email doesn’t look right. Check it and try again.', email);
    err.hidden = true; busy(true);
    // Shopify Messaging keys off these tags. poyo-tN-YYYY-MM is new every month, so a returning
    // winner's tag is always "added" and their automation fires again; poyo-tier-N stays for segments.
    form.querySelector('[data-pg-tags]').value = 'newsletter,poyo-game,poyo-' + mode + ',' + c.tag + ',poyo-tier-' + c.tier + ',poyo-t' + c.tier + '-' + period() + ',poyo-month-' + period();
    klaviyoClaim(c, { email: email.value.trim() })
      .then(function () { return fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }); })
      .then(function (res) {
        if (/challenge/.test(res.url)) {
          // Shopify bot check: do a real submit so the shopper can finish it; the code shows when they come back.
          // Klaviyo already has the claim, so the email is on its way either way.
          set('poyo_resume', '1');
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        done();
      })
      .catch(function () { fail(offline); });
  });

  // Opening the popup deals straight into a game; the email comes after, to claim the code.
  function newGame() {
    syncPeriod();
    arcade = claimed();
    if (!arcade) set('poyo_claim', ''); // a new play replaces any unclaimed prize
    pk = null; mt = null;
    track('poyo_start', { arcade: arcade, plays_left: playsLeft() });
    gameLabel();
    if (arcade) lbStrip(mode);
    startPlay();
  }

  // Picker: choose card match or picture poker.
  function playsNote() {
    if (claimed()) return cfg.arcadeNote || 'You have this month\u2019s code. Play for the leaderboard.';
    var left = playsLeft();
    if (left < 1) return cfg.outNote || 'Out of plays this month. You can still win 5% off.';
    return (cfg.pickNote || '{n} plays left this month for up to 20% off').replace('{n}', left).replace(/^1 plays/, '1 play');
  }
  function showPicker() {
    show('pick');
    var lbl = $('[data-pg-game]'); if (lbl) lbl.textContent = cfg.pickLabel || 'Pick a game';
    playsPill();
    var note = $('[data-pg-pick-note]');
    if (note) note.textContent = playsNote();
    play('idle', true);
    lbBest();
    emit('pick');
    setTimeout(function () { var b = root.querySelector('[data-pg-pick]'); if (b) b.focus({ preventScroll: true }); }, 60);
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pg-pick]'); if (!b) return;
    mode = b.dataset.pgPick === 'match' ? 'match' : 'poker';
    track('poyo_pick', { picked: mode });
    newGame();
  });
  root.addEventListener('click', function (e) { if (e.target.closest('[data-pg-skip]')) close(); });
  // "Try again?" on the email screen: swap the unclaimed prize for another play of the same game
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-pg-retry]')) return;
    var c = claim(); if (!c || c.emailed || playsLeft() < 1) return;
    track('poyo_retry', { gave_up: c.tag, plays_left: playsLeft() });
    newGame();
  });
  // footer: More games opens the picker
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-pg-more]')) { track('poyo_more_games', { from: step }); showPicker(); }
  });

  function winLine(c) {
    if (c.outcome === 'clear' && c.tier === 5 && c.earned > 5) return cfg.capKick || 'Out of plays this month, so it\u2019s the regular 5%';
    return c.outcome === 'clear' ? (mode === 'poker' ? (P.winKick || 'You beat Poyoboy') : (M.clearKick || 'Board cleared')) : (M.missKick || 'Nice try. You still won');
  }
  function showClaim(c) {
    show('claim');
    var rb = $('[data-pg-retry]');
    if (rb) { var left = playsLeft(); rb.hidden = left < 1 || c.tier >= 20; rb.textContent = (cfg.retryLabel || 'Try again?') + ' (' + left + ' play' + (left === 1 ? '' : 's') + ' left)'; }
    $('[data-pg-claim-kick]').textContent = winLine(c);
    $('[data-pg-claim-prize]').textContent = c.label;
    var ask = $('[data-pg-claim-ask]'); if (ask && ask.dataset.line === undefined) ask.dataset.line = ask.textContent;
    setVia(via);
    root.querySelector('.pg-tab span:last-child').textContent = cfg.claimTab || 'Claim your code';
    var btn = form.querySelector('.pg-go'); btn.disabled = false; btn.removeAttribute('aria-busy');
    play('reveal', true);
    emit('claim', { prize: c });
    setTimeout(function () { var i = document.getElementById(via === 'sms' ? 'PoyoGamePhone' : 'PoyoGameEmail'); if (i) i.focus({ preventScroll: true }); }, 60);
  }

  function startPlay() {
    if (mode === 'poker') startPoker(); else startMatch();
  }

  function reveal(c, again, replay) {
    show('reveal');
    var kick = $('[data-step="reveal"] .pg-kick');
    var byApp = cfg.codeSource === 'app';
    var bySms = byApp && c.via === 'sms';
    if (kick) kick.textContent = bySms ? (SMS.kick || 'Check your texts') : byApp ? (cfg.appKick || 'Check your inbox') : (cfg.unlockedKick || 'Your code is unlocked');
    $('[data-pg-prize]').textContent = c.label;
    // with a discount app, the code is emailed; nothing to copy or apply on screen
    $('.pg-code').hidden = byApp; $('[data-pg-apply]').hidden = byApp;
    var note = $('[data-pg-app-note]'); if (note) { note.hidden = !byApp; note.textContent = (bySms ? (SMS.note || 'Reply Y to the text we just sent and your {label} code comes right after.') : (cfg.appNote || 'Your {label} code is on its way to your email.')).replace('{label}', c.label); }
    $('[data-pg-code]').textContent = c.code;
    // app mode: the emailed code is the app's; offer the fixed tier code as an on-screen backup
    var backup = $('[data-pg-backup]');
    if (backup) backup.hidden = !(byApp && cfg.appBackup !== false && c.code);
    $('[data-pg-terms]').textContent = c.terms || '';
    var dest = root.dataset.redirect || '/collections/everything';
    $('[data-pg-apply]').href = '/discount/' + encodeURIComponent(c.code) + '?redirect=' + encodeURIComponent(dest);
    root.querySelector('.pg-tab span:last-child').textContent = cfg.tabLabel || 'Play a game';
    play('reveal', true);
    if (!again) emit('revealed', { prize: c });
  }

  var backupBtn = $('[data-pg-backup]');
  if (backupBtn) backupBtn.addEventListener('click', function () {
    backupBtn.hidden = true;
    $('.pg-code').hidden = false; $('[data-pg-apply]').hidden = false;
    $('[data-pg-copy]').click();
    track('code_backup_shown');
  });
  $('[data-pg-copy]').addEventListener('click', function (e) {
    var b = e.currentTarget, code = $('[data-pg-code]').textContent;
    var done = function () { b.textContent = 'COPIED'; setTimeout(function () { b.textContent = 'COPY'; }, 1600); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () { selectCode(); });
    else selectCode();
  });
  function selectCode() { var r = document.createRange(); r.selectNodeContents($('[data-pg-code]')); var s = getSelection(); s.removeAllRanges(); s.addRange(r); }
  $('[data-pg-apply]').addEventListener('click', function () { track('poyo_apply', { prize: (claim() || {}).tag }); });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-pg-open]')) open('tab');
    else if (e.target.closest('[data-pg-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

  // play(mode) starts a fresh game of the given type; used by previews and testing.
  // Any link to #play (e.g. a "Play" menu item) or element with data-poyo-play opens the picker.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#play"],[data-poyo-play]');
    if (!a || root.contains(a)) return;
    e.preventDefault(); open('pick');
  });
  window.addEventListener('hashchange', function () { if (location.hash === '#play') open('pick'); });

  window.PoyoGame = { open: open, close: close, pick: function () { if (!modal.hidden) close(); open('pick'); }, mode: function () { return mode; },
    play: function (m) { if (m === 'match' || m === 'poker') { mode = m; autoMode = m; } try { localStorage.removeItem('poyo_claim'); } catch (e) {} pk = null; mt = null; if (!modal.hidden) close(); open('demo'); },
    reset: function () { ['poyo_claim', 'poyo_plays', 'poyo_period', 'poyo_snooze'].forEach(function (k) { try { localStorage.removeItem(k); } catch (e) {} }); syncPeriod(); } };

  // ---------- triggers ----------
  navOffset(); window.addEventListener('resize', navOffset);
  root.hidden = false;
  var c0 = claim();
  if (c0 && c0.code && !c0.emailed) root.querySelector('.pg-tab span:last-child').textContent = cfg.claimTab || 'Claim your code';

  // Back from Shopify's bot check after claiming: mark the email done and show the code.
  if (get('poyo_resume') && /customer_posted=true/.test(location.search) && c0 && c0.code) {
    set('poyo_resume', '');
    c0.emailed = true; set('poyo_claim', JSON.stringify(c0));
    track('poyo_signup', { prize: c0.tag, outcome: c0.outcome, via: 'challenge' });
    open('resume');
    return;
  }

  if (location.hash === '#play') { open('pick'); return; }

  var snoozed = +(get('poyo_snooze') || 0) > Date.now();
  if (claimed() || (c0 && c0.code) || snoozed || get('poyo_seen', sessionStorage)) return;

  var pv = (+(get('poyo_pv', sessionStorage) || 0)) + 1;
  set('poyo_pv', String(pv), sessionStorage);
  var needPv = +root.dataset.pageviews || 2;
  if (pv >= needPv) { autoTimer = setTimeout(function () { open('pageview'); }, 1500); return; }
  autoTimer = setTimeout(function () { open('timer'); }, (+root.dataset.delay || 10) * 1000);

  if (root.dataset.exit === 'true' && matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open('exit'); }
    });
  }

})();
